import { __assign, __rest } from "tslib";
import React, { Children, cloneElement, useEffect, useRef } from 'react';
import { useAccordionProps } from '@mercell/use-accordion-react-hook';
import { useExpandedState } from '@mercell/use-expanded-state-react-hook';
import { twMerge } from 'tailwind-merge';
export var Accordion = function (_a) {
    var children = _a.children, _b = _a.isExpanded, isExpanded = _b === void 0 ? false : _b, id = _a.id, className = _a.className, onExpand = _a.onExpand, _c = _a.mountOnlyOnExpand, mountOnlyOnExpand = _c === void 0 ? false : _c, rest = __rest(_a, ["children", "isExpanded", "id", "className", "onExpand", "mountOnlyOnExpand"]);
    var _d = useExpandedState(isExpanded), toggle = _d.toggle, expanded = _d.expanded;
    var _e = useAccordionProps(id, expanded), trigger = _e.trigger, panel = _e.panel;
    var expandedRef = useRef(expanded);
    useEffect(function () {
        if (expanded !== expandedRef.current && onExpand) {
            onExpand(trigger.id, expanded);
            expandedRef.current = expanded;
        }
    }, [expanded, onExpand, trigger.id]);
    return (React.createElement("div", __assign({}, rest, { className: twMerge('rounded-default border border-alto hover:shadow-[2px_2px_12px_0px_#72727240]', className) }), Children.toArray(children).map(function (child) {
        if (child.displayName === 'AccordionHeader' ||
            child.name === 'AccordionHeader' ||
            (child.type || {}).displayName === 'AccordionHeader') {
            return cloneElement(child, {
                toggle: toggle,
                trigger: trigger,
            });
        }
        return cloneElement(child, {
            panel: panel,
            expanded: expanded,
            mountOnlyOnExpand: mountOnlyOnExpand,
        });
    })));
};
